import { convertToDateTime } from '../helper/dateTime-helper';

/**
 * Model to hold a Stripe payout transaction
 */
export class StripePayout {
    public amount: number;
    public createdDateTime: Date;
    public arrivalDateTime: Date;
    public failureCode: string;
    public failureMessage: string;
    public status: string;

    public deserialize(json: any): StripePayout {
        this.amount = json.amount;
        this.failureCode = json.failureCode;
        this.failureMessage = json.failureMessage;
        this.status = json.status;

        if (json.createdDateTime) {
            this.createdDateTime = convertToDateTime(json.createdDateTime);
        }

        if (json.arrivalDateTime) {
            this.arrivalDateTime = convertToDateTime(json.arrivalDateTime);
        }

        return this;
    }
}
